import { action, observable } from 'mobx'

import Ds from './ds'

class UpdateIntervals {
  @observable data = []

  @observable ds = new Ds()

  @action loadAllUpdateIntervals() {
    this.ds.query(`{ updateIntervals(hash: "${ localStorage.getItem('userHash') }") { id name } }`, (data) => {
      this.data = data.updateIntervals
    })
  }

  @action newUpdateInterval(name) {
    this.ds.query(`mutation { addUpdateInterval(name: "${ name }", hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllUpdateIntervals()
    })
  }

  @action updateUpdateInterval(id, name) {
    this.ds.query(`mutation { updateUpdateInterval(id: ${ id }, name: "${ name }", hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllUpdateIntervals()
    })
  }

  @action deleteUpdateInterval(id) {
    this.ds.query(`mutation { deleteUpdateInterval(id: ${ id }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllUpdateIntervals()
    })
  }
}

export default new UpdateIntervals



// WEBPACK FOOTER //
// ./src/stores/updateintervals.js